'use strict';

const formatter = require('../../../modules/utils/formatter');

module.exports = Backbone.View.extend({
    initialize: function(options) {
        this.template = options.template;
        this.type = options.type;
        this.listenTo(this.model.info, 'change', this.render);
    },

    render: function() {
        var model = this.model;
        var info = model.info;
        const roundedPrice = Math.ceil(info.get('price'));
        this.$el.html(this.template({
            price: formatter.formatPrice(roundedPrice),
            duration: formatter.formatDuration(info.get('duration'), model.formats.get('shortDuration')),
            isDynpack: Odigeo.Utils.isRequestApp('dp'),
        }));
        return this;
    },
});
